<template>
  <div>
    <header v-if="show" class="graph-header">
      <slot name="header"></slot>
    </header>
    <slot v-if="show"></slot>
    <div v-else class='ct-flex-column ct-flex-center'>
      <h2>Chargements des données...</h2>
      <div class='spinner'>
        <div class='bounce1'/>
        <div class='bounce2'/>
        <div class='bounce3'/>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'abstract-graph',

  props: {
    show: {
      type: Boolean,
      requied: true
    }
  }
}

</script>
